import { defineMessages } from "react-intl";

import {
	transfusionOccurredMessages,
	validator
} from "lib/build/forms/ktx/basic-registration-data/clinical-data/pre-immunisation/transfusion";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	transfusion: {
		id: "ktx.form.transfusion.title",
		defaultMessage: "Transzfúzió"
	},
	transfusionOccurred: {
		id: "ktx.form.transfusion.transfusion_occurred",
		defaultMessage: "Páciens Transzfúzióban részesült?"
	},
	comment: {
		id: "ktx.form.transfusion.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	transfusionOccurred: {
		type: "field",
		path: ["transfusionOccurred"],
		label: messages.transfusionOccurred,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: transfusionOccurredMessages }
		}
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.transfusionOccurred }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "ktx_transfusion",
	value: {
		schemaId: "transfusion",
		title: messages.transfusion,
		validator,
		fieldset,
		applyCurrentDate: true
	}
};
